import $ from 'jquery';
import _ from 'lodash-es';

export default () => {
  let $container;

  _.every($('[data-section-type="product"]'), (container) => {
    $container = $(container);
    
    if ($('[data-product-json]', $container).length > 0) {
      return false;
    }

    return true;
  });

  return $container;
};